export const getLinkUrl = (link: string) => {
    return link && (link.startsWith("http://") || link.startsWith("https://")) ? link : `https://${link}`;
}